/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef, useEffect } from 'react';
import JobsListingMyTrackPendingApplicationsPage from './pending';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';

const JobsListingMyTrackApplicationsPage = forwardRef(({ ...props }, ref) => {
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { pathname, asPath } = useRouter();

  const getUserSlug = () => {
    return userProfileInfo?.slug || userProfileInfo?.username || null;
  };

  const trackJobTrackingPageVisit = () => {
    const userSlug = getUserSlug();
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.TrackJob, userSlug, {
      page_path: asPath,
      page_title: 'Track Job Applications',
      track_section: pathname,
      device_type: isMobile ? 'mobile' : 'desktop',
      timestamp: new Date().toISOString()
    });
  };

  useEffect(() => {
    if (userProfileInfo && pathname.includes('/track/')) {
      trackJobTrackingPageVisit();
    }
  }, [userProfileInfo, pathname]);

  return (
    <AuthenticatedProviders>
      <JobsListingMyTrackPendingApplicationsPage />
    </AuthenticatedProviders>
  );
});

export default JobsListingMyTrackApplicationsPage;
